import { useState } from "react";
import { Sparkle } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    setLoading(true);
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex bg-navy text-white">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/16571739/pexels-photo-16571739.jpeg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy/90 to-navy" />
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-lg bg-gold flex items-center justify-center">
              <Sparkle size={24} weight="fill" className="text-navy" />
            </div>
            <div className="font-heading font-extrabold text-xl leading-tight">
              Dr. Awish<br />
              <span className="text-gold text-sm font-semibold tracking-widest uppercase">Aesthetic Institute</span>
            </div>
          </div>
        </div>
        <div className="relative z-10 max-w-md">
          <h1 className="font-heading text-4xl font-extrabold leading-tight mb-4">
            One tool to run the entire institute.
          </h1>
          <p className="text-slate-300 text-base leading-relaxed">
            Telecalling, counselling, business development, marketing, operations and finance —
            unified with a live KPI scorecard and AI intelligence.
          </p>
          <div className="flex gap-6 mt-10 text-sm">
            <div><div className="font-heading text-2xl font-bold text-gold">11</div><div className="text-slate-400">Modules</div></div>
            <div><div className="font-heading text-2xl font-bold text-emerald">Live</div><div className="text-slate-400">KPI Tracking</div></div>
            <div><div className="font-heading text-2xl font-bold text-white">AI</div><div className="text-slate-400">Analytics</div></div>
          </div>
        </div>
        <div className="relative z-10 text-xs text-slate-400">© {new Date().getFullYear()} Dr. Awish Aesthetic Institute</div>
      </div>

      {/* Right auth panel */}
      <div className="flex-1 flex items-center justify-center p-8 bg-white text-navy">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="h-10 w-10 rounded-lg bg-gold flex items-center justify-center">
              <Sparkle size={22} weight="fill" className="text-navy" />
            </div>
            <span className="font-heading font-extrabold">Dr. Awish Institute CRM</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate font-semibold mb-2">Team Sign In</p>
          <h2 className="font-heading text-3xl font-extrabold mb-2">Welcome back</h2>
          <p className="text-slate text-sm mb-8">
            Sign in with your Institute Google account to access the CRM.
          </p>
          <button
            data-testid="google-signin-button"
            onClick={handleLogin}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 rounded-lg border border-slate/30 bg-white py-3 px-4 font-semibold text-navy hover:bg-slate-50 hover:-translate-y-[1px] transition-transform duration-200 disabled:opacity-60"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5" />
            {loading ? "Redirecting…" : "Continue with Google"}
          </button>
          <p className="text-xs text-slate mt-6 leading-relaxed">
            Everyone on the team gets the full tool. Personal views like "My Leads" are filtered automatically.
          </p>
        </div>
      </div>
    </div>
  );
}
